var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsLambda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.5 37H72.5C55.103 37 41 51.103 41 68.5V184.5C41 201.897 55.103 216 72.5 216H188.5C205.897 216 220 201.897 220 184.5V68.5C220 51.103 205.897 37 188.5 37Z",
    fill: "white",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_41)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 77H180V177H80V77Z",
    fill: "url(#paint0_linear_1_41)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.965 159.5H100.675L117.582 123.435L125.242 139.535L115.967 159.5H115.965ZM118.677 120.005C118.579 119.795 118.423 119.617 118.227 119.492C118.032 119.367 117.805 119.301 117.572 119.3H117.567C117.335 119.303 117.109 119.371 116.913 119.497C116.718 119.623 116.563 119.802 116.465 120.012L97.62 160.212C97.5306 160.403 97.4901 160.613 97.5023 160.824C97.5146 161.034 97.5791 161.238 97.69 161.417C97.915 161.78 98.3075 162 98.7275 162H116.742C117.217 162 117.65 161.723 117.855 161.285L127.715 140.063C127.794 139.893 127.834 139.709 127.833 139.522C127.832 139.335 127.79 139.151 127.71 138.982L118.677 120.005ZM160.045 159.5H145.34L121.665 107.722C121.568 107.509 121.413 107.327 121.216 107.199C121.019 107.071 120.79 107.002 120.555 107H110.925L110.937 94.5H129.81L153.37 146.275C153.57 146.717 154.01 147 154.485 147H160.045V159.5ZM161.27 144.5H155.27L131.71 92.725C131.613 92.51 131.457 92.3273 131.259 92.1988C131.061 92.0703 130.831 92.0013 130.595 92H109.712C109.384 92.0033 109.07 92.1368 108.84 92.3711C108.61 92.6055 108.482 92.9216 108.485 93.25L108.47 108.25C108.47 108.58 108.6 108.898 108.83 109.135C108.943 109.25 109.078 109.342 109.227 109.405C109.376 109.467 109.536 109.5 109.697 109.5H119.777L143.447 161.277C143.647 161.717 144.082 162 144.56 162H161.275C161.438 161.999 161.599 161.965 161.748 161.902C161.898 161.838 162.034 161.746 162.148 161.63C162.262 161.513 162.352 161.376 162.413 161.225C162.474 161.074 162.504 160.913 162.502 160.75V145.75C162.502 145.06 161.955 144.5 161.275 144.5H161.27Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_41",
    x: 0.5,
    y: 0.5,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_41"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_41",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_41",
    x1: 80,
    y1: 10077,
    x2: 10080,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 77)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsLambda);
export default __webpack_public_path__ + "static/media/aws-lambda.a4e78d39ba322568fe597a64e2bf9bf6.svg";
export { ForwardRef as ReactComponent };